import { render, staticRenderFns } from "./BtnAvaliarRequisicao.vue?vue&type=template&id=8358b9d6"
import script from "./BtnAvaliarRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnAvaliarRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports